export default __webpack_public_path__ + "static/media/sticker-G.77839208.png";